export default __webpack_public_path__ + "static/media/warning--double-side-roads-left--g3.90e3a23d.png";